import http from './http'

export default class affiliateApi {
  static fetchAffiliate(endpoint) {
    return http.get(endpoint)
  }
}
